import {useController, useFormContext} from "react-hook-form";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

const FormTextArea = ({
    name: propsName,
    label,
    placeholder = "",
    maxLength = 4000,
    rows = 2,
    maxRows = 5,
    rules = {},
    disabled = false,
}) => {
    const {control, trigger} = useFormContext();

    const {
        field: {onChange, onBlur, name, value, ref},
        fieldState: {error},
    } = useController({
        name: propsName,
        control,
        rules,
    });

    const inputLabel = rules && rules["required"] ? `${label} *` : label;

    return (
        <FormControl fullWidth error={Boolean(error)} margin="dense">
            <TextField
                name={name}
                value={value}
                label={inputLabel}
                placeholder={placeholder}
                inputRef={ref}
                onChange={event => {
                    onChange(event);
                    if (error) trigger(propsName);
                }}
                onBlur={() => {
                    onBlur();
                    trigger(propsName);
                }}
                error={Boolean(error)}
                helperText={error?.message}
                inputProps={{maxLength: maxLength, style: {padding: 0}}}
                InputLabelProps={{shrink: true}}
                multiline
                minRows={rows}
                maxRows={maxRows}
                disabled={disabled}
                sx={{
                    "& .MuiInputBase-multiline": {
                        padding: "14px",
                    },
                }}
            />
        </FormControl>
    );
};

export default FormTextArea;
